<template>
    <svg
        width="73"
        height="64"
        viewBox="0 0 73 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M72.2334 58.3555L39.6297 1.87942C38.9576 0.715675 37.713 0 36.3687 0C35.0245 0 33.7799 0.715675 33.1077 1.87942L0.504084 58.3555C-0.168028 59.5193 -0.168028 60.9568 0.504084 62.1206C1.1762 63.2843 2.42085 64 3.76507 64H68.9786C70.3228 64 71.5675 63.2843 72.2396 62.1206C72.9055 60.9506 72.9055 59.5193 72.2334 58.3555ZM10.287 56.4699L36.3687 11.289L62.4504 56.4699H10.287Z"
            fill="#AA1E1E" />
        <path
            d="M39.0384 46.7738C38.3227 46.139 37.439 45.8217 36.3686 45.8217C35.3044 45.8217 34.4145 46.139 33.6988 46.7738C32.9831 47.4086 32.6284 48.2176 32.6284 49.2009C32.6284 50.1842 32.9831 50.9932 33.6988 51.628C34.4083 52.2627 35.2982 52.5801 36.3686 52.5801C37.4328 52.5801 38.3227 52.2627 39.0384 51.628C39.7478 50.9932 40.1088 50.1842 40.1088 49.2009C40.1026 48.2114 39.7478 47.4024 39.0384 46.7738Z"
            fill="#AA1E1E" />
        <path
            d="M33.6928 43.009H39.1444L40.0032 23.1257H32.834L33.6928 43.009Z"
            fill="#AA1E1E" />
    </svg>
</template>
